export default function IconChevronRight({ className }: { className?: string }) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
            className={className}
        >
            <path
                d="M10.0627 7L5.6877 11.375L5.0752 10.7625L8.8377 7L5.0752 3.2375L5.6877 2.625L10.0627 7Z"
                fill="black"
            />
        </svg>
    )
}
